
    const data = {"name":"src/core/icons/text-box-check","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m17 21-2.75-3 1.16-1.16L17 18.43l3.59-3.59 1.16 1.41M12.8 21H5a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2v7.8c-.88-.51-1.91-.8-3-.8l-1 .08V11H7v2h7.69A5.983 5.983 0 0 0 12 18c0 1.09.29 2.12.8 3m-.8-6H7v2h5m5-10H7v2h10\"/>","originalColors":[],"stopColors":[]}}

            export default data
            